parameters.controller('ParametersListController', ['$scope', 'ParametersService', 'ParametersResource', '$q', '$uibModal', 'toaster',
    function ($scope, ParametersService, ParametersResource, $q, $uibModal, toaster) {
        ParametersService.scope = $scope;
        ParametersService.resource = ParametersResource;
        $scope.gridOptions = ParametersService.getGridOptions();
        ParametersService.getPage();
    }
]);